module.exports = __webpack_public_path__ + "img/bldc_adc2.0084a900.png";